import { TREES_API_BASE } from './config';

export interface SearchParams {
  message: string;
  venueId: string;
}

export async function searchLocations(params: SearchParams) {
  try {
    const response = await fetch(`${TREES_API_BASE}/api/atriuslink/search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(params),
    });
    
    if (!response.ok) {
      throw new Error('Failed to search locations');
    }
    
    return response.json();
  } catch (error) {
    console.error('Error searching locations:', error);
    throw error;
  }
}
